import apiService from "apiService";
import React, { useContext, useState, useEffect } from "react";
import Card from "../../component/Card";
import Form from "../../component/Form";
import withFormLogic from "../../hoc/withFormLogic";
import withPostFetch from "../../hoc/withPostFetch";
import withReference from "../../hoc/withReference";
import { KunjunganPasienContext } from "view/laporan/Context";

import { getWorkAreas, searchIlpReport } from "view/laporan/DataProvider";
import validationRules from "view/laporan/validationRules";
import moment from "moment";

const FilterForm = ({
  field,
  onChangeHandler,
  dateOnChange,
  reactSelectHandler,
  resetField,
  submitHandler,
  post,
  data,
  validation,
  onLoad,
}) => {
  const { insertStore } = useContext(KunjunganPasienContext);
  const [pkm, setpkm] = useState([]);
  const [ref_cluster, setref_cluster] = useState([
    { label: "Kluster 2 Hamil", value: 21 },
    { label: "Kluster 2 Bayi Balita Prasekolah", value: 22 },
    { label: "Kluster 2 Anak sekolah dan remaja", value: 23 },
    { label: "Kluster 3 Dewasa dan Lansia", value: 31 },
    // { label: "Kluster 3 Lansia", value: 32 },
  ]);

  return (
    <div>
      <Card.SubHeaderWithCollapse header="Filter">
        <Card.Body>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.Select
                label="Kluster"
                value={field.cluster}
                name="cluster"
                placeholder="Pilih..."
                onChange={onChangeHandler}
                options={ref_cluster}
              />
            </Form.Column>
            <Form.Column lg={8} xs={12}>
              <Form.DatePicker
                label="Tanggal mulai"
                size="sm"
                placeholder="dari"
                name="tgl1"
                value={field.tgl1_value}
                onChange={dateOnChange}
              />
              <Form.DatePicker
                label="Tanggal selesai"
                size="sm"
                placeholder="dari"
                name="tgl2"
                value={field.tgl2_value}
                onChange={dateOnChange}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column>
              {JSON.parse(localStorage.getItem("userData")).level === 1 ? (
                <Form.Select
                  label="Puskesmas"
                  options={pkm}
                  value={field.puskesmas_id}
                  name="puskesmas_id"
                  placeholder="Pilih..."
                  onChange={onChangeHandler}
                />
              ) : (
                ""
              )}
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.Select
                label="Desa"
                name="area"
                options={data.work_areas}
                value={field.area}
                onChange={onChangeHandler}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.Select
                label="Domisili"
                name="domisili"
                options={data.work_areas}
                value={field.domisili}
                onChange={onChangeHandler}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={2} xs={12}>
              <button
                className="btn btn-primary btn-block"
                disabled={onLoad}
                onClick={() =>
                  submitHandler(validation, field, (params) => {
                    insertStore({ onLoad: true, params });
                    post(params, (response) =>
                      insertStore({ dataKunjungan: response, onLoad })
                    );
                  })
                }
              >
                Tampilkan
              </button>
            </Form.Column>
            <Form.Column lg={2} xs={12}>
              <button
                className="btn btn-secondary btn-block"
                onClick={resetField}
              >
                Reset
              </button>
            </Form.Column>
          </Form.Row>
        </Card.Body>
      </Card.SubHeaderWithCollapse>
    </div>
  );
};

const field = {
  tgl1: moment().format("YYYY-MM-DD"),
  tgl2: moment().format("YYYY-MM-DD"),
  cluster: "",
  area: "",
  domisili: "",
};

export default withReference(
  [getWorkAreas()],
  ["work_areas"]
)(
  withPostFetch((params) => searchIlpReport(params))(
    withFormLogic(field, validationRules)(FilterForm)
  )
);
